
<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center" >
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("common_1033") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>

      <PdfViewer :src="`${EmployeeHandbookLink}`" />

  </f7-page>
</template>

<script>
import { getCookie, getStore } from "../config/utils";
import PdfViewer from './template/PdfViewer.vue';
import {getInfo } from "../axios/api";

export default {
  components: { PdfViewer },
  props: {},
  data() {
    return {
      EmployeeHandbookLink: getStore('EmployeeHandbookLink'),
    };
  },
  watch: {},
  computed: {},
  methods: {
    
  },
  created() { 

      // getInfo().then((data) => {
      //   if (data.Code === "NoError" && data.Data) {
      //     this.EmployeeHandbookLink = data.Data.BaseInfo.EmployeeHandbookLink;
      //   }
      // });
    
  },
  mounted() { 
    
  },
};
</script>
